export class Message {
    public static readonly WRONG_TEL = "半角数字10桁または11桁で入力してください。";
    public static readonly WRONG_KANA = "全角カタカナで入力してください。";
    public static readonly WRONG_MAIL = "メールアドレスが正しくありません。";
    public static readonly WRONG_BIRTHDAY = "生年月日が正しくありません。";
    public static readonly WRONG_POSTAL_CODE = "郵便番号が正しくありません。";
    public static readonly WRONG_SERIAL_NUMBER = "一連指定番号が正しくありません。";

    public static readonly INPUT_ANOTHER_MAIL = "新しいメールアドレスを入力してください。";

    public static readonly NOT_SAME_MAIL = "メールアドレスが一致しません。";
    public static readonly NOT_INPUT_MAIL = "メールアドレスを入力してください。";
    public static readonly NOT_INPUT_NAME = "お名前を入力してください。";
    public static readonly NOT_INPUT_NAME_KANA = "お名前(カタカナ) を入力してください。";
    public static readonly NOT_NUMBER = "数字で入力してください。";
    public static readonly NOT_FOUND_ADDRESS = "郵便番号に対応する住所が見つかりませんでした。";
    public static readonly NOT_CAR_MAKER = "メーカーを選択してください。";
    public static readonly NOT_CAR_TYPE = "車種を選択してください。";
    public static readonly NOT_UPPER_ALPHA_NUMERIC = "数字かアルファベット大文字で入力してください。";
    public static readonly NOT_FULL_WIDTH_CHAR = "全角文字で入力してください。";
    public static readonly NOT_HIRAGANA_ALPHABET = "ひらがなかアルファベット大文字で入力してください。";
    public static readonly NOT_INPUT_GENDER = "性別を入力してください。";
    public static readonly NOT_INPUT_BIRTHDAY = "生年月日を入力してください。";
    public static readonly NOT_INPUT_PREFECTURE = "都道府県を入力してください。";
    public static readonly NOT_INPUT_WIDTH_ASPECT_RATIO_RIM_XL_Front = "前タイヤサイズの幅・扁平率・リム径・エクストラロード・ランフラットタイヤを入力してください。";
    public static readonly NOT_INPUT_WIDTH_ASPECT_RATIO_RIM_XL_Rea = "後タイヤサイズの幅・扁平率・リム径・エクストラロード・ランフラットタイヤを入力してください。";

    // Auth0のメール再送で使用するメッセージ（変数名はAuth0から返却されるものである）
    public static readonly UNREGISTERED_EMAIL = "登録されていないメールアドレスです。";
    public static readonly VERIFIED_EMAIL = "すでに確認済みです。";
    public static readonly CAN_NOT_RESEND_EMAIL = "このメールアドレスには再送できません。";
    public static readonly CAN_NOT_UPDATE_EMAIL = "このメールアドレスには変更できません。";
    public static readonly SESSION_TIMEOUT = "セッションがタイムアウトしました。操作は完了していないため、再度、実施してください。";
}